import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { auditActions } from "store/actions";
import { getSpRosteringSetting } from "store/selector/sp.selector";
import { canViewAuditLogActivity } from "helpers/RolesPermission";
import ActivityTimeline from "./ActivityTimeline";

const DashboardActivityWidget = () => {
  const dispatch = useDispatch();
  const spRosteringSetting = useSelector(getSpRosteringSetting);
  const canView = canViewAuditLogActivity(spRosteringSetting);
  const loading = useSelector((state) => state.audit?.get("listLoading"));
  const auditData = useSelector((state) => state.audit?.get("auditLogList"));

  useEffect(() => {
    if (!canView) return;
    dispatch(
      auditActions.getAuditLogListRequest({
        per_page: 8,
      })
    );
  }, [dispatch, canView]);

  const activities = auditData?.data || [];

  if (!canView) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <h3 className="text-sm font-semibold text-gray-800">Recent Activity</h3>
        <Link to="/audit-log" className="text-xs text-blue-500 hover:text-blue-700">
          See all
        </Link>
      </div>
      <div className="p-4 max-h-[400px] overflow-y-auto">
        <ActivityTimeline
          activities={activities}
          loading={loading}
          compact={true}
          emptyMessage="No recent activity."
        />
      </div>
    </div>
  );
};

export default DashboardActivityWidget;
